import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  unknown: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
